// Captura en lenguaje natural (Pro): aplica la sugerencia de POST /asistente/captura
// al estado del formulario de QuickAdd. Puro, sin React, para poder probarlo.

const TIPOS = { g: 'gasto', i: 'ingreso', gasto: 'gasto', ingreso: 'ingreso' };

// Fecha local en YYYY-MM-DD (toISOString usa UTC y de noche adelanta un día en México).
export function hoyLocal(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

const FECHA_RE = /^\d{4}-\d{2}-\d{2}$/;

// resp: cuerpo de la respuesta { sugerencia: { tipo, monto, fecha, descripcion } }.
// formActual: { tipo, monto, desc, fecha }. Lo que falte en la sugerencia conserva
// lo que el usuario ya tenía.
export function aplicarCaptura(resp, formActual) {
  const form = { ...formActual };
  const s = resp && typeof resp === 'object' ? resp.sugerencia : null;
  if (!s || typeof s !== 'object') return form;

  if (TIPOS[s.tipo]) form.tipo = TIPOS[s.tipo];

  const m = Number(s.monto);
  if (s.monto !== null && s.monto !== undefined && s.monto !== '' && Number.isFinite(m) && m > 0) {
    form.monto = String(m);
  }

  if (typeof s.fecha === 'string' && FECHA_RE.test(s.fecha)) form.fecha = s.fecha;

  if (typeof s.descripcion === 'string' && s.descripcion.trim() !== '') {
    form.desc = s.descripcion.trim();
  }
  return form;
}
